// import { useSubscriptionStore } from '@mygpt/app/subscription/store';
import { EnableKey } from '@mygpt/app/apis/services/plan';

// 默认不可以访问，触发接口返回true
export const CanAccess = ({ children, accessKey }: { children: React.ReactNode; accessKey: EnableKey }) => {
  // const { subscriptionInfo } = useSubscriptionStore();

  // if (!subscriptionInfo) {
  //   return null;
  // }

  // if (subscriptionInfo[accessKey] === false) {
  //   return null;
  // }

  return children;
};
